import React from "react";
import styled from "styled-components";
import { injectStripe, PaymentRequestButtonElement } from "react-stripe-elements";

class PaymentRequestForm extends React.Component {
  constructor(props) {
    super(props);

    // For full documentation of the available paymentRequest options, see:
    // https://stripe.com/docs/stripe.js#the-payment-request-object
    const paymentRequest = props.stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: this.props.label || "Top Nine",
        amount: parseInt(this.props.amount || 199),
      },
    });

    paymentRequest.on("click", () => {
      if (window.gtag) {
        window.gtag("event", "checkout_progress", {
          event_label: this.state.applePay ? "applePay" : "paymentRequest",
        });
        window.gtag("event", `onclick_${this.state.applePay ? "applePay" : "paymentRequest"}`);
      }
    });
    paymentRequest.on("token", ({ complete, token, ...data }) => {
      complete("success");
      this.props.onTokenSuccess(token, this.state.applePay ? "applePay" : "paymentRequest");
    });

    paymentRequest.canMakePayment().then(result => {
      this.setState({
        canMakePayment: !!result,
        applePay: result && result.applePay,
      });
    });

    this.state = {
      canMakePayment: false,
      applePay: false,
      paymentRequest,
    };
  }

  render() {
    return this.state.canMakePayment ? (
      <ApplePayButton>
        <PaymentRequestButtonElement
          paymentRequest={this.state.paymentRequest}
          className="PaymentRequestButton"
          style={{
            // For more details on how to style the Payment Request Button, see:
            // https://stripe.com/docs/elements/payment-request-button#styling-the-element
            paymentRequestButton: {
              theme: "dark",
              height: "41px",
            },
          }}
        />
      </ApplePayButton>
    ) : null;
  }
}

const ApplePayButton = styled.div`
  width: 100%;
  margin-bottom: 8px;
`;

const PaymentRequestButton = injectStripe(PaymentRequestForm);

export default PaymentRequestButton;
